export enum LayoutType {
    Default = 'default',
    Retiro = 'retiro'
}

const DEFAULT_LINK_ID = 'layout-default-css';
const RETIRO_LINK_ID = 'layout-retiro-css';

function getLink(id: string): HTMLLinkElement | null {
    return document.getElementById(id) as HTMLLinkElement | null;
}

export function applyLayoutStyle(layout: LayoutType): void {
    const defaultLink = getLink(DEFAULT_LINK_ID);
    const retiroLink = getLink(RETIRO_LINK_ID);

    if (!defaultLink || !retiroLink) {
        return;
    }

    if (layout === LayoutType.Default) {
        defaultLink.disabled = false;
        retiroLink.disabled = true;
    } else {
        defaultLink.disabled = true;
        retiroLink.disabled = false;
    }
}